import React, { useCallback, useEffect, useState } from "react";
import { Form, Input as InputField, InputNumber, message } from "antd";
import Checkbox from "../../../components/common/checkBox";
import Dropdown from "../../../components/common/dropdown";
import Button from "../../../components/common/button";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { register } from "../../../api/auth";
import { fetchBusinessTypes } from "../../../store/slices/businessSlice";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "../../../components/common/handlePhoneInput";
import { ReactComponent as LocationMarker } from "./../../../assets/icons/location.svg";
import { ReactComponent as ColouredMarker } from "./../../../assets/icons/maplocation.svg";
import MapModal from "../../../components/Map/ModalMap";
import { UsaStates } from "usa-states";

const CreateAccount = () => {
  const [loader, setLoader] = useState(false);
  const [value, setValue] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [saveClicked, setSaveClicked] = useState(false);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const usStates = new UsaStates();
  const showModal = (id) => {
    setIsModalOpen(true);
  };
  const hideModal = () => {
    setIsModalOpen(false);
    setSaveClicked(true);
    form.validateFields(["businessAddress"]);
  };
  const longitude = localStorage.getItem("Longitude");
  const latitude = localStorage.getItem("Latitude");
  const onFinish = async (values) => {
    setLoader(true);
    const payload = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phoneNumber: values.phoneNumber,
      password: values.password,
      isBusiness: true,
      business: {
        businessTypeId: values.businessTypeId,
        businessAddress: values.businessAddress,
        numberOfLocations: values.locations,
        businessDescription: values.businessDescription,
        yearsInBusiness: values.yearsInBusiness || 0,
        businessLocation: {
          coordinates: [+longitude, +latitude],
        },
        staffSize: values.staffSize || 0,
        city: values.city,
        state: values.state,
        zipCode: values.zipCode.toString(),
        businessName: values.businessName,
      },
    };
    if (values?.suiteNumber) {
      payload.business.suiteNumber = values?.suiteNumber?.toString();
    }
    if (values?.website) {
      payload.business.website = values?.website;
    }
    try {
      const res = await register(payload);
      if (res) {
        setLoader(true);
        message.success("Registered Successfully");
        localStorage.setItem("email", values.email);
        localStorage.setItem("phone", values.phoneNumber);
        // navigate("/otp");
        window.location.href = "/otp";
      }
    } catch (error) {
      message.error(error);
    } finally {
      setLoader(false);
    }
  };
  const locationValidator = (rule, value) => {
    if (!saveClicked) {
      return Promise.reject("Please Select your Location!");
    } else {
      return Promise.resolve();
    }
  };
  const getBusinessTypes = useCallback(() => {
    dispatch(fetchBusinessTypes());
  }, [dispatch]);

  const data = useSelector((state) => {
    return state.business.value;
  });

  useEffect(() => {
    getBusinessTypes();
  }, [getBusinessTypes]);

  const locationsData = [{ _id: 1 }, { _id: 2 }, { _id: 3 }, { _id: 4 }];
  return (
    <div
      className={`flex flex-col items-center jusitfy-center w-full lg:overflow-x-hidden relative ${
        isModalOpen ? "blur-sm" : ""
      }`}
    >
      <div className="flex flex-col w-full items-center lg:items-start lg:w-fit lg:p-5">
        <div className="text-start w-full ">
          <p className="font-bold text-2xl lg:text-3xl pl-3 lg:pl-0 ">
            Create An Account
          </p>
          <p className="pl-3 lg:pl-0 font-normal">Let's get started!</p>
        </div>
        <Form
          form={form}
          onFinish={onFinish}
          className="w-full p-3 lg:grid lg:grid-cols-2 lg:gap-3 lg:mt-5 lg:p-0"
        >
          <div className="">
            <div className="lg:flex lg:space-x-2">
              <Form.Item
                className="lg:w-full"
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Your First Name",
                  },
                ]}
              >
                <InputField
                  className={"w-full h-5.4 rounded-lg"}
                  placeholder="First Name"
                />
              </Form.Item>
              <Form.Item
                name="lastName"
                className="lg:w-full"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Your Last Name",
                  },
                ]}
              >
                <InputField
                  className={"w-full h-5.4 rounded-lg "}
                  placeholder="Last Name"
                />
              </Form.Item>
            </div>
            <Form.Item
              name="email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid email!",
                },
                {
                  required: true,
                  message: "Please Enter Your email!",
                },
              ]}
            >
              <InputField
                className={"w-full h-5.4 rounded-lg "}
                placeholder="Email"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please Enter Your Password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || (value.length >= 6 && /[A-Z]/.test(value))) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      "Password must be at least 6 characters with 1 uppercase letter"
                    );
                  },
                }),
              ]}
            >
              <InputField.Password
                className={"w-full h-5.4 rounded-lg"}
                placeholder="Password"
              />
            </Form.Item>

            <Form.Item
              name="repeatpassword"
              rules={[
                {
                  required: true,
                  message: "Please Enter Your Password Again!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The new password that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <InputField.Password
                className={"w-full h-5.4 rounded-lg"}
                placeholder="Repeat Password"
              />
            </Form.Item>
            <Form.Item
              name="phoneNumber"
              rules={[
                {
                  required: true,
                  pattern: /^\+1 \(\d{3}\) \d{3}-\d{4}$/,
                  message: "Please add correct number",
                },
              ]}
              className="w-full"
            >
              <PhoneInput />
            </Form.Item>
            <Form.Item
              className="hidden font-medium lg:flex"
              name="tandc"
              valuePropName="name"
            >
              <Checkbox
                onChecked={(value) => setValue(value)}
                description="By Signing Up I Confirm That I Agree The"
                link={
                  <Link
                    to="/terms-conditions"
                    className="no-underline text-primaryPurple ml-0.4"
                    target="_blank"
                  >
                    Terms & Conditions.
                  </Link>
                }
              />
            </Form.Item>
            <Link to="/login" className="hidden lg:block no-underline lg:mt-9">
              <p className="text-grey">Back to Login</p>
            </Link>
          </div>
          <div>
            <Form.Item
              name="businessTypeId"
              rules={[
                {
                  required: true,
                  message: "Please Select Business Type",
                },
              ]}
            >
              <Dropdown placeholder="Business Type" data={data} />
            </Form.Item>
            <Form.Item
              name="businessName"
              rules={[
                {
                  required: true,
                  message: "Please Enter Business Name",
                },
              ]}
            >
              <InputField
                className={"w-full h-5.4 rounded-lg"}
                placeholder="Business Name"
              />
            </Form.Item>
            <Form.Item
              name="businessAddress"
              rules={[
                {
                  required: true,
                  message: "Please Enter Business Address",
                },
                { validator: locationValidator },
              ]}
            >
              <InputField
                className={"w-full h-5.4 rounded-lg"}
                placeholder="Business Address"
                suffix={
                  <div className="hover:cursor-pointer " onClick={showModal}>
                    {saveClicked ? <ColouredMarker /> : <LocationMarker />}
                  </div>
                }
              />
            </Form.Item>
            <Form.Item
              name="businessDescription"
              className="lg:w-full"
              rules={[
                {
                  required: true,
                  message: "field is required",
                },
              ]}
            >
              <InputField
                className={"w-full h-5.4 rounded-lg"}
                placeholder="Business Description"
              />
            </Form.Item>
            <div className="lg:flex lg:space-x-2">
              <Form.Item
                className="lg:w-full"
                name="suiteNumber"
                rules={[{ required: false, message: "field is required" }]}
              >
                <InputField
                  className={"w-full h-5.6 flex items-center rounded-lg"}
                  controls={false}
                  placeholder="Suite Number"
                />
              </Form.Item>

              <Form.Item
                className="lg:w-full"
                name="zipCode"
                rules={[
                  { required: true, message: "field is required" },
                  {
                    pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                    message: "Please enter a positive number",
                  },
                ]}
              >
                <InputNumber
                  className={"w-full h-5.4 flex items-center rounded-lg"}
                  type="number"
                  controls={false}
                  placeholder="ZIP Code"
                />
              </Form.Item>
            </div>
            <div className="lg:flex lg:space-x-2">
              <Form.Item
                className="lg:w-full"
                name="city"
                rules={[{ required: true, message: "field is required" }]}
              >
                <InputField
                  className={"w-full h-5.6 flex items-center rounded-lg"}
                  placeholder="City"
                />
              </Form.Item>

              <Form.Item
                className="lg:w-full"
                name="state"
                rules={[{ required: true, message: "field is required" }]}
              >
                <Dropdown
                  className={"w-full h-5.4 flex items-center rounded-lg"}
                  data={usStates?.states}
                  placeholder="State"
                />
              </Form.Item>
            </div>

            <div className="lg:flex lg:space-x-2">
              <Form.Item
                name="website"
                className="lg:w-full"
                rules={[
                  {
                    required: false,
                    message: "Please Enter Your Website",
                  },
                ]}
              >
                <InputField
                  className={"w-full h-5.4 rounded-lg"}
                  placeholder="Website"
                />
              </Form.Item>
              <Form.Item
                className="lg:w-full"
                name="locations"
                rules={[
                  {
                    required: true,
                    message: "field is required",
                  },
                ]}
              >
                <Dropdown
                  className={"w-full h-5.4 flex items-center rounded-lg"}
                  data={locationsData}
                  placeholder="Number of Locations"
                />
              </Form.Item>
            </div>
            <div className="lg:flex lg:space-x-2">
              <Form.Item
                className="lg:w-full"
                name="yearsInBusiness"
                rules={[
                  { required: true, message: "field is required" },
                  {
                    pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                    message: "Please enter a positive number",
                  },
                ]}
              >
                <InputNumber
                  className={"w-full h-5.4 flex items-center rounded-lg"}
                  type="number"
                  controls={false}
                  placeholder="Years In Business"
                />
              </Form.Item>
              <Form.Item
                className="lg:w-full"
                name="staffSize"
                rules={[
                  { required: true, message: "field is required" },
                  {
                    pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                    message: "Please enter a positive number",
                  },
                ]}
              >
                <InputNumber
                  className={"w-full h-5.4 flex items-center rounded-lg"}
                  type="number"
                  controls={false}
                  placeholder="Staff Size"
                />
              </Form.Item>
            </div>
            <Form.Item className="block lg:hidden font-medium" name="tandc">
              <Checkbox
                onChecked={(value) => setValue(value)}
                description="By Signing Up I Confirm That I Agree The "
                link={
                  <Link
                    to="/terms-conditions"
                    className="no-underline text-primaryBlue ml-0.4"
                    target="_blank"
                  >
                    Terms & Conditions.
                  </Link>
                }
              />
              <Link to="/login" className=" lg:block no-underline lg:mt-9">
                <p className="text-grey">Back to Login</p>
              </Link>
            </Form.Item>
            <Form.Item className="lg:mt-5 w-full lg:flex lg:justify-end">
              <Button
                loading={loader}
                disabled={!value}
                htmlType="submit"
                className={
                  !value
                    ? "w-full md:w-19 !text-grey"
                    : "w-full md:w-19 !bg-primaryPurple"
                }
                title="Register"
              />
            </Form.Item>
          </div>
        </Form>
      </div>
      {isModalOpen && (
        <MapModal title="Choose Your Location" onOk={hideModal} />
      )}
    </div>
  );
};

export default CreateAccount;
